// hooks/useWhatsappActivityListData.ts
import { getInactiveUserEmail, getWhatsappActivity } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useInactiveUserEmailListData = (startDate: string, endDate: string) => {
    const query = useDataQuery(['inactive-email', startDate, endDate], () => getInactiveUserEmail(startDate, endDate));

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useInactiveUserEmailListData;
